import { oc } from "@orpc/contract";

export const OC = oc;
